import { serializeError } from "owa-offline-errors";

// Serialize errors thrown in worker actions to ensure full info makes it back to the main thread
export function serializeRejection<T extends (...args: any[]) => Promise<any>>(fn: T): T {
    return async function (...args: Parameters<T>): Promise<ReturnType<T>> {
        try {
            return await fn(...args);
        }
        catch (error) {
            // Errors resulting from enabling useUnknownInCatchVariables
            // TS2345: Argument of type 'unknown' is not assignable to parameter of type 'ApolloError | Error | GraphQLError | TraceErrorObject | null | undefined'.
            // @ts-expect-error
            throw serializeError(error);
        }
    } as T;
}
